module.exports = __webpack_public_path__ + "static/media/icon_service_unavailable.8c897fe9.svg";